import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  ListItemIcon,
} from "@mui/material";

// project imports
import NavItem from "../NavItem";

// assets
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { menuActive } from "store/menuReducer";
import noImg from "assets/images/noImg.svg";

// ==============================|| SIDEBAR MENU LIST COLLAPSE ITEMS ||============================== //

const NavCollapse = ({ menu, level }) => {
  const theme = useTheme();
  const menuState = useSelector((state) => state.menu);
  const [open, setOpen] = useState(true);
  const [selected, setSelected] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const [openedId] = menuState?.isActive;
    if (openedId === menu.id) {
      setSelected(true);
    } else {
      setSelected(false);
    }
  }, [menu, menuState]);

  /* useEffect(() => {
        if (menu?.url.includes(location?.pathname?.split('/')[1])) {
            dispatch({ type: MENU_OPEN, id: menu.id });
        }
        menu?.children.forEach((item) => {
            if (item?.url.includes(location?.pathname?.split('/')[1])) {
                dispatch({ type: MENU_OPEN, id: item.id });
            }
        });
    }, [location, dispatch, menu]); */

  const handleClick = () => {
    const [openedId] = menuState.isActive;
    setOpen(!open);
    if (openedId === menu.id) dispatch(menuActive(null));
    else dispatch(menuActive(menu?.id));
  };

  // menu collapse & item
  const menus = menu.children?.map((item) => {
    if (item.children !== null)
      return <NavCollapse key={item.title} menu={item} level={level + 1} />;
    else return <NavItem key={item.title} item={item} level={level + 1} />;
  });

  // const Icon = Loadable(
  //   lazy(() =>
  //     import("@tabler/icons").then((module) => {
  //       return {
  //         default: module[menu.icon],
  //       };
  //     })
  //   )
  // );

  // const menuIcon = menu?.icon ? (
  //   <Icon stroke={1.5} size="1.3rem" />
  // ) : (
  //   <FiberManualRecordIcon
  //     sx={
  //       {
  //         // width: menu.isActive.findIndex((id) => id === menu?.id) > -1 ? 8 : 6,
  //         // height: menu.isActive.findIndex((id) => id === menu?.id) > -1 ? 8 : 6,
  //       }
  //     }
  //     fontSize={level > 0 ? "inherit" : "medium"}
  //   />
  // );

  // const img = (src) => {
  //   try {
  //     const res = require(`../../../../../assets${menu?.imgSrc}`);
  //     return res;
  //   } catch {
  //     return null;
  //   }
  // };

  return (
    <React.Fragment key={menu?.title}>
      <ListItemButton
        sx={{
          mb: 0.5,
          alignItems: "flex-start",
          pl: `${level * 24}px`,
        }}
        selected={selected}
        // onClick={() => itemHandler(item.id)}
        onClick={handleClick}
      >
        <ListItemIcon sx={{ my: "auto" }}>
          {menu?.imgSrc && (
            <img src={noImg} alt="Xcelvations Logo" height="18px" />
          )}
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography sx={{ my: "auto", fontWeight: "bold", fontSize: 14 }}>
              {menu.title}
            </Typography>
          }
          secondary={
            menu.caption && (
              <Typography
                variant="caption"
                sx={{ ...theme.typography.subMenuCaption }}
                display="block"
                gutterBottom
              >
                {menu.caption}
              </Typography>
            )
          }
        />
        {open ? (
          <ExpandLess
            stroke={1.5}
            size="1rem"
            style={{ marginTop: "auto", marginBottom: "auto" }}
          />
        ) : (
          <ExpandMore
            stroke={1.5}
            size="1rem"
            style={{ marginTop: "auto", marginBottom: "auto" }}
          />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          sx={{
            position: "relative",
            "&:after": {
              content: "''",
              position: "absolute",
              left: "32px",
              top: 0,
              height: "100%",
              opacity: 1,
              background: theme.palette.primary.light,
            },
          }}
        >
          {menus}
        </List>
      </Collapse>
    </React.Fragment>
  );
};

NavCollapse.propTypes = {
  menu: PropTypes.object,
  level: PropTypes.number,
};

export default NavCollapse;
